import { useRouter } from 'next/router';
import React from 'react';
import Cookies from 'react-cookies';
import { useSelector } from 'react-redux';
import COOKIES from '../../config/cookies/cookies';
import { LINK_CHECKOUT } from '../../config/links/links';
import { redirectToURL } from '../../helpers/url';
import HeaderBuyAgain from './HeaderBuyAgain';
import HeaderIcon from './HeaderIcon';
import HeaderLocation from './HeaderLocation';
import HeaderLogin from './HeaderLogin';
import HeaderSubscribe from './HeaderSubscribe';
import HeaderWishlist from './HeaderWishlist';

const HeaderButtons = () => {
  const router = useRouter();
  const wishlistQuantity = useSelector((state) => state.wishlist.quantity);
  const quantity = useSelector((state) => state.basket.quantity);

  const moveToPage = () => {
    const basketToken = Cookies.load(COOKIES.basketToken);
    if (basketToken && basketToken.length > 10) {
      redirectToURL(`${LINK_CHECKOUT}/${basketToken}`, router);

      return;
    }
    redirectToURL(LINK_CHECKOUT, router);
  };

  return (
    <>
      <HeaderBuyAgain
        brand={process.env.NEXT_PUBLIC_BRAND}
        countryCode={process.env.NEXT_PUBLIC_COUNTRY_CODE}
        site={process.env.NEXT_PUBLIC_SITE}
      />
      <HeaderLocation
        brand={process.env.NEXT_PUBLIC_BRAND}
        countryCode={process.env.NEXT_PUBLIC_COUNTRY_CODE}
        site={process.env.NEXT_PUBLIC_SITE}
      />
      <HeaderSubscribe />
      <HeaderLogin />
      <HeaderWishlist quantity={wishlistQuantity} />
      <HeaderIcon
        badgeContent={quantity}
        clickMethod={() => moveToPage()}
        icon="basket"
      />
    </>
  );
};

export default HeaderButtons;
